import { set } from 'date-fns';
import { useFormContext } from 'react-hook-form';

import { DateRubric, RUBRIC_TYPES } from '../../Datatable.types';

export const useFilterDate = ({
  filter,
  onChange,
}: {
  filter: DateRubric;
  onChange: (selectedFilter: DateRubric) => void;
}) => {
  const { getValues } = useFormContext();

  const handleStartDateChange = (
    date: Date | [Date | null, Date | null] | undefined,
  ) => {
    if (!date) {
      onChange({
        name: filter.name,
        label: filter.label,
        maxValue: getValues(`filterEndDate_${filter.name}`),
        minValue: undefined,
        type: RUBRIC_TYPES.DATE,
        filterName: `filterStartDate_${filter.name}`,
      });
    } else if (!Array.isArray(date)) {
      const newDate = set(date, {
        hours: 1,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      });

      onChange({
        name: filter.name,
        label: filter.label,
        maxValue: getValues(`filterEndDate_${filter.name}`),
        minValue: newDate,
        type: RUBRIC_TYPES.DATE,
        filterName: `filterStartDate_${filter.name}`,
      });
    }
  };

  const handleEndDateChange = (
    date: Date | [Date | null, Date | null] | undefined,
  ) => {
    if (!date) {
      onChange({
        name: filter.name,
        label: filter.label,
        maxValue: undefined,
        minValue: getValues(`filterStartDate_${filter.name}`),
        type: RUBRIC_TYPES.DATE,
        filterName: `filterEndDate_${filter.name}`,
      });
    } else if (!Array.isArray(date)) {
      const newDate = set(date, {
        hours: 23,
        minutes: 59,
        seconds: 59,
        milliseconds: 999,
      });

      onChange({
        name: filter.name,
        label: filter.label,
        maxValue: newDate,
        minValue: getValues(`filterStartDate_${filter.name}`),
        type: RUBRIC_TYPES.DATE,
        filterName: `filterEndDate_${filter.name}`,
      });
    }
  };

  return {
    startDate:
      getValues(`filterStartDate_${filter.name}`) === ''
        ? undefined
        : getValues(`filterStartDate_${filter.name}`),
    endDate:
      getValues(`filterEndDate_${filter.name}`) === ''
        ? undefined
        : getValues(`filterEndDate_${filter.name}`),
    handleStartDateChange,
    handleEndDateChange,
  };
};
